export const useJweb = () => window.JWeb;
